export default "__VITE_ASSET__BhbCMhH3__"